export default [
  {
    field: {
      id: 'name',
      label_en: 'Name',
      label_ru: 'Имя',
      name: 'name',
      type: 'text',
      max: 30,
      min: 1,
    },
    required: true,
    order: -2,
  },
  {
    field: {
      id: 'surname',
      label_en: 'Surname',
      label_ru: 'Фамилия',
      name: 'surname',
      type: 'text',
      max: 30,
      min: 1,
    },
    required: true,
    order: -3,
  },
  {
    field: {
      id: 'email',
      label_en: 'Email',
      label_ru: 'Email',
      name: 'email',
      type: 'text',
    },
    required: true,
    order: -4,
  },
  {
    field: {
      id: 'participationType',
      name: 'participationType',
      type: 'select',
      label_ru: 'Формат участия',
      label_en: 'Participation type',
      placeholder_ru: 'Выбрать из списка',
      placeholder_en: 'Select from list',
      regexp: null,
      min: null,
      max: null,
      options: [
          {
              id: 1,
              value: 'online',
              label_ru: 'онлайн',
              label_en: 'online'
          },
          {
              id: 2,
              value: 'offline',
              label_ru: 'офлайн',
              label_en: 'offline'
          }
      ],
    },
    required: true,
    order: -4,
  }
  // {
  //   field: {
  //     id: 'patronymic',
  //     label_en: 'Patronymic',
  //     label_ru: 'Отчество',
  //     name: 'patronymic',
  //     type: 'text',
  //     max: 30,
  //     min: 1,
  //   },
  //   order: -1,
  // },
];
